import React, { useEffect, useRef } from "react";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import { Box, Button, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import useBackend from "../../hooks/use_backend";
import { REACT_QUERY_KEYS } from "../../enums/react_query_key_enum";
import { fetchSiteData, fetchState } from "../../scripts/api_v2/commands_client";
import { useQuery } from "@tanstack/react-query";
import { useSiteData } from "hooks/use_site";

export function LiveActionList() {
  const params = useParams();
  const backend = useBackend();

  const { data, isFetching, error } = useQuery({
    queryKey: [REACT_QUERY_KEYS.LIVE_ACTION_LIST, backend.fetch, params.site_id],
    queryFn: async () => {
      try {
        return await fetchState(backend.fetch, params.site_id, "action-log");
      } catch (error) {
        console.error("Error in query function:", error);
        throw error; // Rethrow to let react-query handle it
      }
    },
    refetchInterval: 1000,
    enabled: !!params.site_id,
  });

  const actions = Array.isArray(data)
    ? data
    : data && typeof data === "object"
      ? Object.values(data).filter((value) => value && typeof value === "object")
      : [];

  return !error ? (
    <Box ml={1} display="flex" flexDirection="column" height="100%" width="100%">
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 1 }}>
        Action List
      </Typography>
      {actions.map((action, index) => (
        <Action
          key={index}
          index={index}
          target={action.flex_target}
          current={action.flex}
          type={action.type}
          mode={action.mode}
          powerType={action.power_type}
          targetType={action.target}
          targetId={action.target_id}
        />
      ))}
    </Box>
  ) : (
    <div>{error?.message || "Error loading data"}</div>
  );
}

function Action({ index, target, current, type, mode, powerType, targetType, targetId }) {
  return (
    <Typography variant="body2" fontWeight="bold" sx={{ color: "black" }}>
      {index + 1}. <b style={{ color: type == "FLEX" ? "orange" : "purple" }}>{type}</b> {targetType}{" "}
      {powerType == 1 ? "REACTIVE" : ""} {mode} {targetId ? "[" + targetId + "]" : null}{" "}
      <b style={{ color: "grey" }}>
        {current} | {target}
      </b>
    </Typography>
  );
}
